import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import API, { saveSession, mensajeDeError } from '../api';
import './Login.css';
import { useT } from '../i18n';
import LangToggle from '../components/LangToggle';
import { IS_PHONE } from '../device';
import { useLogo } from '../theme';

export default function Login() {
  const logoSrc = useLogo();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const t = useT();

  // Aviso que dejan otras pantallas al llegar aquí ("Contraseña cambiada",
  // "Revisa tu correo"). Viaja en el estado de la navegación y no en la URL a
  // propósito: así no queda en el historial ni se puede enviar a nadie un enlace
  // que finja un mensaje del sistema.
  // `avisoKey` es una clave de traducción (así el aviso cambia de idioma con el
  // interruptor); `aviso` queda para textos ya escritos.
  const estado = location.state || {};
  const aviso = estado.avisoKey ? t(estado.avisoKey) : estado.aviso;

  const handleLogin = async (e) => {
    e.preventDefault();
    if (enviando) return;
    setError('');
    setEnviando(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      saveSession(res.data.token, res.data.user);
      navigate('/music');
    } catch (err) {
      // Se enseña lo que diga el servidor y no un texto fijo. La diferencia
      // importa: quien lleva cinco intentos fallidos necesita leer "espera 15
      // minutos", porque si le decimos "credenciales incorrectas" se queda
      // probando su contraseña —que es la correcta— sin entender qué pasa.
      setError(mensajeDeError(err, t('auth.login.errorFallback')));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      <LangToggle style={{ position: 'fixed', top: 12, right: 16, zIndex: 10 }} />
      {/* Teléfono: sin vídeo de fondo (pesa y gasta batería); queda el degradado. */}
      {!IS_PHONE && (
        <video className="login-video-bg" autoPlay muted playsInline loop>
          <source src="/videos/background.mp4" type="video/mp4" />
        </video>
      )}

      <div className="login-overlay" />

      <div className="login-container">
        <div className="login-card-glow">
          <div className="login-card">
            <div className="login-logo">
              <img src={logoSrc} alt="DragonAudio" className="logo-img" />
              <h1 className="login-title">DragonAudio</h1>
            </div>

            {aviso && <p className="login-aviso">{aviso}</p>}
            {error && <p className="login-error">{error}</p>}

            <form onSubmit={handleLogin} className="login-form">
              <input
                type="email" placeholder={t('auth.field.email')} value={email}
                onChange={e => setEmail(e.target.value)}
                className="login-input"
                autoComplete="email" required
              />
              <input
                type="password" placeholder={t('auth.field.password')} value={password}
                onChange={e => setPassword(e.target.value)}
                className="login-input"
                autoComplete="current-password" required
              />
              {/* Bloqueado mientras se envía: sin esto, un doble clic manda dos
                  peticiones, y si la contraseña está mal eso gasta DOS de los
                  cinco intentos que tiene el usuario antes del bloqueo. */}
              <button type="submit" className="login-btn" disabled={enviando}>
                {enviando ? t('auth.login.submitting') : t('auth.login.submit')}
              </button>
            </form>

            <p className="login-olvide">
              <Link to="/forgot-password">{t('auth.login.forgot')}</Link>
            </p>

            <p className="login-register">
              {t('auth.login.noAccount')} <Link to="/register">{t('auth.login.register')}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
